import {
  axiosAssessmentInstance,
  axiosAuthInstance,
} from "../AxiosConfiguration";
import Cookies from "js-cookie";

export const updateNotificationSettings = async (data) => {
  try {
    const response = await axiosAssessmentInstance.post(
      `/api/notification/settings/update`,
      data
    );
    return response?.data?.payload;
  } catch (error) {
    throw error;
  }
};

export const getNotificationSettings = async () => {
  try {
    const response = await axiosAssessmentInstance.get(
      `/api/notification/settings`
    );
    return response?.data?.payload;
  } catch (error) {
    console.error("Error during API call:", error);
    return error;
  }
};

export const updateEmailSettings = async (data) => {
  try {
    const response = await axiosAuthInstance.put(
      `/auth/v2/user/email/update`,
      data
    );

    if (response.data.status_code === 200) {
      // Store Device_id in cookies
      const deviceId =
        response.headers["Device_id"] || response.headers["device_id"];
      if (deviceId) {
        Cookies.set("Device_id", deviceId);
      } else {
        console.error("Device ID not found in headers");
      }

      return response?.data;
    }
  } catch (error) {
    console.error("Error during API call:", error);
    return error;
  }
};

export const sendUpdatedEmail = async (email) => {
  try {
    const response = await axiosAuthInstance.post(
      `/auth/v2/user/email/update`,
      { email },
      {
        headers: {
          Authorization: `Bearer ${Cookies.get("idtoken")}`,
          Device_id: Cookies.get("Device_id"),
        },
      }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const verifyUpdatedEmail = async ({ email, otp }) => {
  try {
    const response = await axiosAuthInstance.post(
      `/auth/v2/user/email/update/verify`,
      { email, otp: String(otp) },
      {
        headers: {
          Authorization: `Bearer ${Cookies.get("idtoken")}`,
          Device_id: Cookies.get("Device_id"),
        },
      }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const resendEmail = async ({ email }) => {
  try {
    const response = await axiosAuthInstance.post(
      `/auth/v2/user/email/update/resend`,
      { email },
      {
        headers: {
          Authorization: `Bearer ${Cookies.get("idtoken")}`,
          Device_id: Cookies.get("Device_id"),
        },
      }
    );
    return response?.data;
  } catch (error) {
    console.error("Error during API call:", error);
    return error;
  }
};

// Phone number updation

export const sendUpdatedContact = async (data) => {
  try {
    const response = await axiosAuthInstance.post(
      `/auth/v2/contact/update`,
      data,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get("idtoken")}`,
        },
      }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const checkOTP = async (data) => {
  try {
    const response = await axiosAuthInstance.post(
      `/auth/v2/contact/update/verify`,
      data
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const resendOTP = async (data) => {
  try {
    const response = await axiosAuthInstance.post(
      `/auth/v2/contact/update/resend-otp`,
      data,
      {
        headers: {
          Authorization: `Bearer ${Cookies.get("idtoken")}`,
        },
      }
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};
